// import { BrowserModule } from '@angular/platform-browser';
// import { NgModule, ChangeDetectorRef } from '@angular/core';
// import { AppRoutingModule } from './app-routing.module';
// import { AppComponent } from './app.component';
// import { LoginComponent } from './auth/login/login.component';
// import { LogoutComponent } from './auth/logout/logout.component';
// import { DaoService } from './services/dao.service';
// import { ThemeService } from 'src/app/shared/theme.service';
// import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
// import { SpinnerComponent } from 'src/app/shared/spinner/spinner.component';
// import { ToastService } from './services/toast.service';

// import {
//   MatInputModule,
//   MatCheckboxModule,
//   MatSelectModule,
//   MatMenuModule,
//   MatPaginatorModule,
//   MatSortModule,
//   MatRadioModule,
// } from '@angular/material';

// import { MatTooltipModule } from '@angular/material/tooltip';
// import { MatTabsModule } from '@angular/material/tabs';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgOtpInputModule } from 'ng-otp-input';
// import { MatDialogModule, MatOption } from '@angular/material';
// //Tree
// import { CdkTableModule } from '@angular/cdk/table';
// import { CdkTreeModule } from '@angular/cdk/tree';

// import { MatTreeModule } from '@angular/material';
// import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
// import { MatSnackBarModule } from '@angular/material';

// //Admin change
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatIconModule } from '@angular/material/icon';
// import { MatTableModule } from '@angular/material/table';
// import { MatCardModule } from '@angular/material/card';
// import { MatDividerModule } from '@angular/material/divider';
// import { HttpClientModule } from '@angular/common/http';
// /* Directives */
// import { AllowOnlyNumbersDirective } from './directives/allow-only-numbers.directive';
// import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
// import { ApiManagerComponent } from './admin/api-manager/api-manager.component';
// import { ApiMappingComponent } from './admin/api-mapping/api-mapping.component';
// import { HeaderComponent } from './admin/header/header.component';
// import { AttributeComponent } from './admin/attribute/attribute.component';
// import { EntityComponent } from './admin/entity/entity.component';
// import { EntityformComponent } from './admin/entityform/entityform.component';
// import { CategoryComponent } from './admin/category/category.component';
// import { CategoryformComponent } from './admin/categoryform/categoryform.component';
// import { SubcategoryComponent } from './admin/subcategory/subcategory.component';
// import { SubcategoryformComponent } from './admin/subcategoryform/subcategoryform.component';
// import { CreateComponent } from './admin/create/create.component';
// import { UserComponent } from './admin/user/user.component';
// import { UserformComponent } from './admin/userform/userform.component';
// import { UserconfigComponent } from './admin/userconfig/userconfig.component';
// import { UseractivityComponent } from './admin/useractivity/useractivity.component';
// import { UseraccountlockformComponent } from './admin/useraccountlockform/useraccountlockform.component';
// import { UserdeleteComponent } from './admin/userdelete/userdelete.component';
// // import { MatSelectSearchComponent } from './mat-select-search/mat-select-search.component';
// import { AnalyticsComponent } from './analytics/analytics.component';
// import { from } from 'rxjs';
// import { AnalyticsformComponent } from './admin/analyticsform/analyticsform.component';
// import { ApiGroupComponent } from './admin/api-group/api-group.component';
// import { ChecklistDatabase } from './admin/api-group/api-group.component';
// import { ApigrouplistComponent } from './admin/apigrouplist/apigrouplist.component';
// import { ApiResponseMappingListComponent } from './admin/api-response-mapping-list/api-response-mapping-list.component';
// import { ApiResponseMappingComponent } from './admin/api-response-mapping/api-response-mapping.component';
// import { RepositoryComponent } from './admin/repository/repository.component';
// import { RepositoryformComponent } from './admin/repositoryform/repositoryform.component';
// import { TemplateListComponent } from './admin/template-list/template-list.component';
// import { AttributeListComponent } from './admin/attribute-list/attribute-list.component';
// import { OrderByPipe } from './order-by.pipe';

//start
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgOtpInputModule } from "ng-otp-input";

// Angular Material imports
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTreeModule } from "@angular/material/tree";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./auth/login/login.component";
import { LogoutComponent } from "./auth/logout/logout.component";
import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { AllowOnlyNumbersDirective } from "./directives/allow-only-numbers.directive";
import { ApiManagerComponent } from "./admin/api-manager/api-manager.component";
import { ApiMappingComponent } from "./admin/api-mapping/api-mapping.component";
import { HeaderComponent } from "./admin/header/header.component";
import { AttributeComponent } from "./admin/attribute/attribute.component";
import { EntityComponent } from "./admin/entity/entity.component";
import { EntityformComponent } from "./admin/entityform/entityform.component";
import { CategoryComponent } from "./admin/category/category.component";
import { SubcategoryComponent } from "./admin/subcategory/subcategory.component";
import { SubcategoryformComponent } from "./admin/subcategoryform/subcategoryform.component";
import { CreateComponent } from "./admin/create/create.component";
import { CategoryformComponent } from "./admin/categoryform/categoryform.component";
import { UserComponent } from "./admin/user/user.component";
import { UserformComponent } from "./admin/userform/userform.component";
import { UserconfigComponent } from "./admin/userconfig/userconfig.component";
import { UseraccountlockformComponent } from "./admin/useraccountlockform/useraccountlockform.component";
import { UserdeleteComponent } from "./admin/userdelete/userdelete.component";
import { UseractivityComponent } from "./admin/useractivity/useractivity.component";
import { AnalyticsComponent } from "./analytics/analytics.component";
import { AnalyticsformComponent } from "./admin/analyticsform/analyticsform.component";
import {
  ApiGroupComponent,
  ChecklistDatabase,
} from "./admin/api-group/api-group.component";
import { ApigrouplistComponent } from "./admin/apigrouplist/apigrouplist.component";
import { ApiResponseMappingListComponent } from "./admin/api-response-mapping-list/api-response-mapping-list.component";
import { ApiResponseMappingComponent } from "./admin/api-response-mapping/api-response-mapping.component";
import { RepositoryComponent } from "./admin/repository/repository.component";
import { RepositoryformComponent } from "./admin/repositoryform/repositoryform.component";
import { TemplateListComponent } from "./admin/template-list/template-list.component";
import { AttributeListComponent } from "./admin/attribute-list/attribute-list.component";
import { OrderByPipe } from "./order-by.pipe";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { AppRoutingModule } from "./app-routing.module";
import { DaoService } from "./services/dao.service";
import { ThemeService } from "./shared/theme.service";
import { SpinnerService } from "./shared/spinner/spinner.service";
import { ToastService } from "./services/toast.service";
import { MatSelectSearchComponent } from "ngx-mat-select-search/mat-select-search.component";
import { MatSelectSearchClearDirective } from "ngx-mat-select-search/mat-select-search-clear.directive";
import { MatSelectSearchModule } from "./mat-select-search/mat-select-search.module";
//end

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    PagenotfoundComponent,
    AllowOnlyNumbersDirective,
    ApiManagerComponent,
    ApiMappingComponent,
    HeaderComponent,
    AttributeComponent,
    EntityComponent,
    EntityformComponent,
    CategoryComponent,
    SubcategoryComponent,
    SubcategoryformComponent,
    CreateComponent,
    CategoryformComponent,
    UserComponent,
    UserformComponent,
    UserconfigComponent,
    UseraccountlockformComponent,
    UserdeleteComponent,
    UseractivityComponent,
    AnalyticsComponent,
    AnalyticsformComponent,
    ApiGroupComponent,
    ApigrouplistComponent,
    ApiResponseMappingListComponent,
    ApiResponseMappingComponent,
    RepositoryComponent,
    RepositoryformComponent,
    TemplateListComponent,
    AttributeListComponent,
    OrderByPipe,
    SpinnerComponent,
    ApiGroupComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatCheckboxModule,
    NgbModule,
    MatDialogModule,
    MatFormFieldModule,

    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
    MatSelectModule,
    MatDividerModule,
    MatRadioModule,
    CdkTableModule,
    CdkTreeModule,
    MatTreeModule,
    MatTabsModule,
    MatTooltipModule,
    MatSnackBarModule,
    NgOtpInputModule,
  ],
  providers: [
    DaoService,
    ThemeService,
    ChecklistDatabase,
    ApiResponseMappingListComponent,
    SpinnerService,
    SpinnerComponent,
    ApiGroupComponent,
    ToastService,
    MatSelectSearchModule,
    ApiGroupComponent,
  ],
  bootstrap: [AppComponent],
  // entryComponents: [
  //   AnalyticsformComponent,
  //   EntityformComponent,
  //   CategoryformComponent,
  //   SubcategoryformComponent,
  //   UserformComponent,
  //   UserconfigComponent,
  //   UseraccountlockformComponent,
  //   UseractivityComponent,
  //   RepositoryformComponent,
  //   UserdeleteComponent,
  //   ApiGroupComponent,
  // ],
  exports: [AnalyticsformComponent],
})
export class AppModule {}
